const openCreateAssessmentDialog = works => ({
  type: 'WORKS_STORE:CREATE_ASSESSMENT_DIALOG:OPEN',
  params: {
    selectedWorks: works
  }
})

const closeCreateAssessmentDialog = () => ({
  type: 'WORKS_STORE:CREATE_ASSESSMENT_DIALOG:CLOSE'
})

export { openCreateAssessmentDialog, closeCreateAssessmentDialog }
